'use client';

/**
 * React Query Provider
 * Provides data fetching and caching for the entire app
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { QueryCacheAuthSync } from './query-cache-auth-sync';
import { RecommendationFeedbackProvider } from './recommendation-feedback-provider';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // Data considered fresh for 1 minute
            gcTime: 5 * 60 * 1000, // Cache garbage collected after 5 minutes
            retry: 1, // Retry failed requests once
            refetchOnWindowFocus: false, // Don't refetch on window focus
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <QueryCacheAuthSync />
      <RecommendationFeedbackProvider>{children}</RecommendationFeedbackProvider>
    </QueryClientProvider>
  );
}
